import { PassengersState } from './reducers';
import { PassengerTypeConfig } from '../../types';
import { isInfant } from '../../components/SearchForm/Passengers/utils';
import { PassengerType } from '../../../enums';

export const isResetSelectedOnlyInfants = (state: PassengersState, passengersConfig: PassengerTypeConfig[]) => {
	let isReset = true;

	Object.entries(state).forEach(([passengerType, count]) => {
		const passengerConfig = passengersConfig.find(config => config.code === passengerType);

		if (
			(isInfant(passengerConfig) && count > 0 && count <= passengerConfig?.maxCountWithoutAdult) ||
			(!isInfant(passengerConfig) && count > 0)
		) {
			isReset = false;
		}
	});

	return isReset;
};

export const getPassengerCountByType = (passengers: PassengersState, searchingType: PassengerType) => {
	return Object.entries(passengers).reduce<number>(
		(sum, [type, count]) => (type === searchingType ? sum + (count || 0) : sum),
		0
	);
};

export const setPassengerCountLessOrEqualAdt = (
	state: PassengersState,
	adultCount: number,
	passengersConfig: PassengerTypeConfig[],
	passengerCode: PassengerType
) => {
	const newState = { ...state };

	const passengerConfig = passengersConfig.find(
		config => config.code === passengerCode || config.parentCode === passengerCode
	);
	const currentCount = getPassengerCountByType(newState, passengerConfig?.code as PassengerType);

	if (newState[passengerCode] || newState[passengerConfig?.code]) {
		const passengerPath = newState[passengerCode] ? passengerCode : passengerConfig?.code;
		newState[passengerPath] = adultCount <= currentCount ? adultCount : currentCount;
	}

	return newState;
};
